import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'h-fit w-full max-w-52 justify-between px-0 normal-case sm:max-w-56.25',
    button: 'flex-center mx-auto normal-case',
    label: 'grow-1',
    buttonChildren: 'flex-center w-full gap-2',
    icon: 'rotate-90',
    input: 'h-8 py-0'
  }
});
